import { Outlet, useParams } from "react-router-dom";
import { prefix } from ".";
import { useEffect } from "react";
import { IDispatch } from '@/actions';
import { useDispatch } from "react-redux";
import ActionType from "@/actions/action-type";

const Layout = () => {
  const { businessID = '' } = useParams();
  const dispatch: IDispatch = useDispatch();

  useEffect(() => {
    if (businessID) {
      dispatch({
        type: ActionType.LOADING_MAIN_DATA,
        businessId: businessID,
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`${prefix}`}>
      <Outlet />
    </div>
  );
};

export default Layout;